import { BookmarkApiData, ReferenceType } from '.';
import { Label } from '../../../../components/labels/lib/entities';

export class BookmarkDTO {
	id: string;
	referenceId: string;
	companyId: string;
	referenceType: ReferenceType;
	labels: Array<Label>;
	notes: string;
	constructor(data: BookmarkApiData) {
		this.id = data.id;
		this.referenceId = data.reference_id;
		this.companyId = data.company_id;
		this.referenceType = data.reference_type as ReferenceType;
		this.labels = data.labels?.map((label) => new Label({ ...label, readOnly: true })) ?? [];
		this.notes = data.notes;
	}
}
